import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const MeetingTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { upcomingMeetingsCount, meetingSentCount, meetingInvitesCount } =
    useSelector((state) => state.meeting);

  const pageNames = [
    {
      title: `Upcoming Meetings (${upcomingMeetingsCount})`,
      tab: "upcoming",
      route: "/meetings/upcoming",
    },
    {
      title: `Meetings Sent (${meetingSentCount})`,
      tab: "sent",
      route: "/meetings/sent",
    },
    {
      title: `Meetings Received (${meetingInvitesCount})`,
      tab: "received",
      route: "/meetings/received",
    },
  ];

  return (
    <div className="bg-main rounded-xl px-5 py-3 flex gap-5">
      {pageNames?.map((item, index) => (
        <div
          onClick={() => navigate(item?.route)}
          key={index}
          className={`p-2 rounded-lg cursor-pointer ${
            item?.route === location.pathname
              ? "text-black bg-white font-bold"
              : "bg-main text-white font-semibold"
          }`}
        >
          {item?.title}
        </div>
      ))}
    </div>
  );
};

export default MeetingTabs;
